import React, { useState } from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { Button, EmptyFilePill, FilePill, UserPill } from '@gtintel/platform-atoms';
import { PENDING_ID } from '@gtintel/platform-constants';
import { ProjectTags } from '../../../components/ProjectTags';
import { ScopeList } from '../../../components/ScopeCard';
import { StatusDisplay } from '../../../components/StatusDisplay';
import { SubjectList } from '../../../components/SubjectCard';
import { ProjectContext, ScopeComponentsContext, SubjectsContext } from '../../context';
import ProjectDetailsCard from '../ProjectDetails';
import * as S from './styles';
const ProjectServiceDescription = () => {
  const [css] = useStyletron();
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [declineLoading, setDeclineLoading] = useState(false);
  const {
    name: projectName,
    instructionsHtml: projectInstructionsHtml,
    sampleReport,
    reportTemplate,
    status,
    acceptProject,
    declineProject,
    data
  } = React.useContext(ProjectContext);
  const {
    list: scopes
  } = React.useContext(ScopeComponentsContext);
  const {
    list: subjects
  } = React.useContext(SubjectsContext);
  const accept = () => {
    setAcceptLoading(true);
    acceptProject().finally(() => setAcceptLoading(false));
  };
  const decline = () => {
    setDeclineLoading(true);
    declineProject().finally(() => setDeclineLoading(false));
  };
  return <S.DescriptionContainer>
      <HeadingLevel>
        <div className={css({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        '@media only screen and (max-width: 768px)': {
          flexDirection: 'column',
          gap: '8px'
        }
      })}>
          <Heading data-testId="project-name-label">{projectName()}</Heading>
          {status() === PENDING_ID ? <div className={css({
          display: 'flex',
          gap: '8px'
        })}>
              <Button kind="error" onClick={decline} loading={declineLoading} disabled={declineLoading}>
                Decline
              </Button>
              <Button onClick={accept} loading={acceptLoading} disabled={acceptLoading} testId="accept-match-button">
                Accept
              </Button>
            </div> : <StatusDisplay status={status()} />}
        </div>

        <ProjectDetailsCard />

        <div className={css({
        marginBottom: '14px'
      })}>
          <HeadingLevel>
            <Heading styleLevel={5}>CX Lead</Heading>
          </HeadingLevel>
          <UserPill user={data().cx_lead} showName background="#f6fafb" empty_message="No CX Lead set" />
        </div>

        <ProjectTags />

        {projectInstructionsHtml() && projectInstructionsHtml() !== '' && <S.Section>
            <HeadingLevel>
              <Heading styleLevel={4}>Instructions</Heading>
            </HeadingLevel>
            <div dangerouslySetInnerHTML={{
          __html: projectInstructionsHtml()
        }}></div>
          </S.Section>}
        <S.Section>
          <S.AttachmentContainer>
            {reportTemplate() ? <FilePill file={reportTemplate()} linkText="Report Template" /> : <EmptyFilePill linkText="Report Template missing. Contact GTI" />}
            {sampleReport() && <FilePill file={sampleReport()} linkText="Example" />}
          </S.AttachmentContainer>
        </S.Section>
        <HeadingLevel>
          <SubjectList subjects={subjects()} />
          <ScopeList scopes={scopes()} />
        </HeadingLevel>
      </HeadingLevel>
    </S.DescriptionContainer>;
};
export default ProjectServiceDescription;